var hcja = hcja || {};

hcja.accordion = {

    // Collapses "search" elements when width is at or below minwidth, or expands them when going above minwidth
    collapseOnResize: function (search, width, minwidth) {
        if (width > minwidth) {
            $(search).collapse('show');
        }
        else {
            $(search).collapse('hide');
        }
    }

};
